import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconAmplitudeSizeS from './IconAmplitude_size_s';

const props: CreateIconArguments = {
  l: IconAmplitudeSizeS,
  m: IconAmplitudeSizeS,
  s: IconAmplitudeSizeS,
  xs: IconAmplitudeSizeS,
  name: 'IconAmplitude',
  renderType: { l: 'default', m: 'default', s: 'default', xs: 'default' },
  color: 'multiple',
};

export default props;
